<div class="table-area-monitoramento">
  <!-- Campo de busca -->
  <div class="search-container">
    <mat-form-field class="search-field">
      <mat-label>Buscar áreas de monitoramento</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        placeholder="Digite para buscar..."
        (input)="onSearch()"
        (keyup.enter)="onSearch()"
      />
      <ng-container matSuffix>
        @if (searchControl.value) {
          <button
            mat-icon-button
            (click)="clearText()"
            [attr.aria-label]="'Limpar texto'"
          >
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <mat-icon>search</mat-icon>
        }
      </ng-container>
    </mat-form-field>
  </div>

  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }
  <mat-card appearance="outlined">
    <div class="table-container">
      <table
        #table
        mat-table
        [dataSource]="dataSource()"
        matSort
        matSortStart="desc"
        (matSortChange)="onSortChange($event)"
        class="mat-elevation-z8 responsive-table"
      >
        <!-- Coluna ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>
        <!-- Coluna Território único -->
        <ng-container matColumnDef="uniqueTerritoryFieldValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("uniqueTerritoryFieldValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.uniqueTerritoryFieldValue }}
          </td>
        </ng-container>
        <!-- Coluna CAR (movel_id) -->
        <ng-container matColumnDef="carFieldValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("carFieldValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.carFieldValue }}
          </td>
        </ng-container>

        <!-- Coluna Contrato -->
        <ng-container matColumnDef="contractFieldValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("contractFieldValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.contractFieldValue }}
          </td>
        </ng-container>

        <!-- Coluna Apólice de seguro -->
        <ng-container matColumnDef="insurancePolicyFieldValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("insurancePolicyFieldValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.insurancePolicyFieldValue }}
          </td>
        </ng-container>

        <!-- Coluna ID do produtor -->
        <ng-container matColumnDef="producerIdFieldValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("producerIdFieldValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.producerIdFieldValue }}
          </td>
        </ng-container>

        <!-- Coluna Documento de identidade -->
        <ng-container matColumnDef="identityDocumentFieldValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("identityDocumentFieldValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.identityDocumentFieldValue }}
          </td>
        </ng-container>

        <!-- Coluna Nome da fazenda -->
        <ng-container matColumnDef="customerFarmNameValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("customerFarmNameValue") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.customerFarmNameValue }}
          </td>
        </ng-container>

        <!-- Coluna Área de operação (ha) -->
        <ng-container matColumnDef="areaOperationHa">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("areaOperationHa") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.areaOperationHa }}
          </td>
        </ng-container>

        <!-- Coluna Município -->
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("city") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.city }}
          </td>
        </ng-container>

        <!-- Coluna UF -->
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("state") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.state }}
          </td>
        </ng-container>

        <!-- Coluna Data Hora -->
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ getColumnLabel("createdDate") }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdDate | date: "dd/MM/yyyy HH:mm:ss" }}
          </td>
        </ng-container>

        <!-- Definir cabeçalho e linhas da tabela -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="element-row"
        ></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell"
            [attr.colspan]="displayedColumns.length"
            style="text-align: center"
          >
            Nenhum dado disponível
          </td>
        </tr>
      </table>
    </div>
  </mat-card>

  <!-- Paginator -->
  <mat-paginator
    #paginator
    [length]="length()"
    [pageSize]="10"
    (page)="onPageChange($event)"
    showFirstLastButtons
    aria-label="Selecione a página das áreas de monitoramento"
    class="paginator"
  >
  </mat-paginator>
</div>
